module.exports = __webpack_public_path__ + "img/mini-player.2a410e05.svg";